import { useEffect, useRef } from 'react'
import { Flex, Card, Text, Button } from '@buffer-mono/popcorn'
import type { SavedReply } from '~publish/gql/graphql'
import styles from './SavedRepliesPopover.module.css'
import clsx from 'clsx'

export const SavedReplyItem = ({
  savedReply,
  handleInsertSavedReply,
  isSelected,
  onMouseEnter,
  onMouseLeave,
}: {
  savedReply: SavedReply
  handleInsertSavedReply: (savedReply: SavedReply) => void
  isSelected: boolean
  onMouseEnter: () => void
  onMouseLeave: () => void
}): JSX.Element => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (isSelected && buttonRef.current) {
      buttonRef.current.focus()
    }
  }, [isSelected])

  return (
    <Card
      padding="sm"
      className={clsx(styles.savedReplyItem, isSelected && styles.isSelected)}
      role="option"
      aria-selected={isSelected}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Flex
        direction="row"
        justify="between"
        align="center"
        gap="2xs"
        fullHeight
      >
        <Flex
          direction="column"
          gap="2xs"
          align="center"
          className={styles.savedReplyItemContent}
        >
          {savedReply?.title && (
            <Text truncate className={styles.title}>
              {savedReply?.title}
            </Text>
          )}
          <Text truncate className={styles.content}>
            {savedReply?.content?.text}
          </Text>
        </Flex>
        <Button
          variant="primary"
          size="medium"
          className={styles.insertButton}
          ref={buttonRef}
          onClick={(): void => {
            handleInsertSavedReply(savedReply)
          }}
        >
          Insert
        </Button>
      </Flex>
    </Card>
  )
}
